import React from 'react';
import { YMInitializer } from 'react-yandex-metrika';

import { YANDEX_METRIKA } from 'const';

const YMetrika: React.FC = () => {
	return (
		<>
			<YMInitializer
				accounts={[YANDEX_METRIKA]}
				options={{
					clickmap: true,
					trackLinks: true,
					accurateTrackBounce: true,
					ecommerce: 'dataLayer',
					webvisor: true,
				}}
			/>
			<noscript>
				<div>
					<img
						src={`https://mc.yandex.ru/watch/${YANDEX_METRIKA}`}
						style={{ position: 'absolute', left: '-9999px' }}
						alt=""
					/>
				</div>
			</noscript>
		</>
	);
};

export default YMetrika;
